import { Component, EventEmitter, Input, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, Validators } from '@angular/forms';
import * as i0 from "@angular/core";
import * as i1 from "@angular/forms";
import * as i2 from "@angular/common";
import * as i3 from "primeng/inputtextarea";
import * as i4 from "ngx-skeleton-loader";
import * as i5 from "../field-error/field-error.component";
import * as i6 from "@ngx-translate/core";
const _c0 = (a0, a1) => ({
  "gea-always-float-label": a0,
  "gea-never-float-label": a1
});
const _c1 = a0 => ({
  "gea-floating ": a0
});
const _c2 = () => ({
  height: "125px",
  width: "100%"
});
function TextfieldV2Component_div_0_label_5_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, " *");
    i0.ɵɵelementEnd();
  }
}
function TextfieldV2Component_div_0_label_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 8);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtemplate(3, TextfieldV2Component_div_0_label_5_span_3_Template, 2, 0, "span", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("htmlFor", ctx_r1.id);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1, ctx_r1.initialValue));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 4, ctx_r1.label), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.required);
  }
}
function TextfieldV2Component_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "span", 4)(2, "textarea", 5);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵlistener("blur", function TextfieldV2Component_div_0_Template_textarea_blur_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleBlur());
    });
    i0.ɵɵtext(4, "    ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, TextfieldV2Component_div_0_label_5_Template, 4, 8, "label", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "geaui-field-error", 7);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.group);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(17, _c0, ctx_r1.floatLabelType === "always", ctx_r1.floatLabelType === "never"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", ctx_r1.group ? (tmp_3_0 = ctx_r1.formName) !== null && tmp_3_0 !== undefined ? tmp_3_0 : ctx_r1.id : "textfield")("placeholder", ctx_r1.floatLabelType === "never" ? i0.ɵɵpipeBind1(3, 13, ctx_r1.label) + (ctx_r1.required ? " *" : "") : "")("id", ctx_r1.group ? ctx_r1.id : "textfield")("value", ctx_r1.initialValue)("disabled", ctx_r1.isDisabled);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.floatLabelType !== "never");
    i0.ɵɵadvance();
    i0.ɵɵproperty("fieldName", i0.ɵɵpipeBind1(7, 15, ctx_r1.label))("submitted", ctx_r1.submitted)("showRequiredErrorWithoutSubmit", ctx_r1.showRequiredErrorWithoutSubmit)("touched", ctx_r1.touched)("errors", ctx_r1.control == null ? null : ctx_r1.control.errors);
  }
}
function TextfieldV2Component_ngx_skeleton_loader_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-skeleton-loader", 10);
  }
  if (rf & 2) {
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c2));
  }
}
export class TextfieldV2Component {
  formBuilder;
  destroyed;
  label = '';
  id = 'textfield';
  formName = undefined;
  group;
  required = false;
  disabled = false;
  initialValue = '';
  loading = false;
  submitted = false;
  showRequiredErrorWithoutSubmit = false;
  floatLabelType = 'auto';
  valueChanged = new EventEmitter();
  touched = false;
  constructor(formBuilder, destroyed) {
    this.formBuilder = formBuilder;
    this.destroyed = destroyed;
    this.group = this.group || this.formBuilder.group({
      [this.formName ?? this.id]: new FormControl('', [])
    });
  }
  get control() {
    return this.group.get(this.formName ?? this.id);
  }
  get isDisabled() {
    return this.control?.disabled;
  }
  ngOnInit() {
    if (this.id === '') {
      throw new Error('please provide an id for the form field');
    }
    if (this.required) {
      this.control?.addValidators(Validators.required);
    }
    if (this.initialValue) {
      this.control?.setValue(this.initialValue);
    }
    this.control?.valueChanges.pipe(takeUntilDestroyed(this.destroyed)).subscribe(value => {
      this.valueChanged.emit(value);
    });
  }
  ngOnChanges(changes) {
    if (changes['disabled']) {
      const isDisabled = changes['disabled'].currentValue;
      isDisabled ? this.control?.disable() : this.control?.enable();
    }
  }
  handleBlur() {
    this.touched = true;
  }
  static ɵfac = function TextfieldV2Component_Factory(t) {
    return new (t || TextfieldV2Component)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i0.DestroyRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: TextfieldV2Component,
    selectors: [["geaui-textfield-v2"]],
    inputs: {
      label: "label",
      id: "id",
      formName: "formName",
      group: "group",
      required: "required",
      disabled: "disabled",
      initialValue: "initialValue",
      loading: "loading",
      submitted: "submitted",
      showRequiredErrorWithoutSubmit: "showRequiredErrorWithoutSubmit",
      floatLabelType: "floatLabelType"
    },
    outputs: {
      valueChanged: "valueChanged"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 3,
    vars: 2,
    consts: [["class", "gea-textfield-container gea-form-container-margin", 3, "formGroup", 4, "ngIf"], [1, "gea-form-container-margin"], ["count", "1", "appearance", "line", 3, "theme", 4, "ngIf"], [1, "gea-textfield-container", "gea-form-container-margin", 3, "formGroup"], [1, "p-float-label", 3, "ngClass"], ["rows", "5", "cols", "30", "pInputTextarea", "", "data-cy", "input", 1, "gea-textfield", 3, "blur", "formControlName", "placeholder", "id", "value", "disabled"], ["data-cy", "label", 3, "ngClass", "htmlFor", 4, "ngIf"], [3, "fieldName", "submitted", "showRequiredErrorWithoutSubmit", "touched", "errors"], ["data-cy", "label", 3, "ngClass", "htmlFor"], [4, "ngIf"], ["count", "1", "appearance", "line", 3, "theme"]],
    template: function TextfieldV2Component_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, TextfieldV2Component_div_0_Template, 8, 20, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtemplate(2, TextfieldV2Component_ngx_skeleton_loader_2_Template, 1, 2, "ngx-skeleton-loader", 2);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.loading);
      }
    },
    dependencies: [i2.NgClass, i2.NgIf, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, i1.FormGroupDirective, i1.FormControlName, i3.InputTextarea, i4.NgxSkeletonLoaderComponent, i5.FieldErrorComponent, i6.TranslatePipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TextfieldV2Component, [{
    type: Component,
    args: [{
      selector: 'geaui-textfield-v2',
      template: "<div class=\"gea-textfield-container gea-form-container-margin\" *ngIf=\"!loading\" [formGroup]=\"group\">\n  <span\n    class=\"p-float-label\"\n    [ngClass]=\"{ 'gea-always-float-label': floatLabelType === 'always', 'gea-never-float-label': floatLabelType === 'never' }\">\n    <textarea\n      class=\"gea-textfield\"\n      [formControlName]=\"group ? (this.formName ?? this.id) : 'textfield'\"\n      [placeholder]=\"floatLabelType === 'never' ? (label | translate) + (required ? ' *' : '') : ''\"\n      [id]=\"group ? id : 'textfield'\"\n      [value]=\"initialValue\"\n      [disabled]=\"isDisabled\"\n      (blur)=\"handleBlur()\"\n      rows=\"5\"\n      cols=\"30\"\n      pInputTextarea\n      data-cy=\"input\">\n    </textarea>\n    <label *ngIf=\"floatLabelType !== 'never'\" [ngClass]=\"{ 'gea-floating ': initialValue }\" htmlFor=\"{{ id }}\" data-cy=\"label\">\n      {{ label | translate }}\n      <span *ngIf=\"required\"> *</span>\n    </label>\n  </span>\n  <geaui-field-error\n    [fieldName]=\"label | translate\"\n    [submitted]=\"submitted\"\n    [showRequiredErrorWithoutSubmit]=\"showRequiredErrorWithoutSubmit\"\n    [touched]=\"touched\"\n    [errors]=\"control?.errors\">\n  </geaui-field-error>\n</div>\n<div class=\"gea-form-container-margin\">\n  <ngx-skeleton-loader\n    *ngIf=\"loading\"\n    [theme]=\"{ height: '125px', width: '100%' }\"\n    count=\"1\"\n    appearance=\"line\"></ngx-skeleton-loader>\n</div>\n"
    }]
  }], () => [{
    type: i1.FormBuilder
  }, {
    type: i0.DestroyRef
  }], {
    label: [{
      type: Input
    }],
    id: [{
      type: Input
    }],
    formName: [{
      type: Input
    }],
    group: [{
      type: Input
    }],
    required: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    initialValue: [{
      type: Input
    }],
    loading: [{
      type: Input
    }],
    submitted: [{
      type: Input
    }],
    showRequiredErrorWithoutSubmit: [{
      type: Input
    }],
    floatLabelType: [{
      type: Input
    }],
    valueChanged: [{
      type: Output
    }]
  });
})();
